<template>
  <div class="box">
    <div class="operation">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        class="form"
        :inline="true"
      >
        <el-form-item
          label="套餐类型"
          label-position="right"
          class="mt"
        >
          <el-select
            v-model="form.type"
            placeholder="请选择"
            clearable
          >
            <el-option
              label="优享"
              value="0"
            ></el-option>
            <el-option
              label="畅享"
              value="1"
            ></el-option>
            <el-option
              label="尊享"
              value="2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="套餐名称"
          label-position="right"
          class="mt"
        >
          <el-input
            v-model="form.packageName"
            size="small"
            placeholder="请输入套餐名称"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="mt">
        <el-button
          type="primary"
          class="btn"
          @click="queryFunc"
          icon="el-icon-search"
        >查询</el-button>
        <el-button
          class="btn"
          @click="clearFunc"
          icon="el-icon-delete"
        >重置</el-button>
        <el-button
          class="primary"
          @click="addFunc"
          icon="el-icon-plus"
        >添加套餐信息</el-button>
        <el-button
          type="danger"
          class="btn"
          @click="doDelete()"
          icon="el-icon-delete"
          :disabled="selections.length === 0"
        >删除</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="tabBox">
      <el-table
        v-loading="loading"
        ref="selections"
        show-overflow-tooltip="true"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        border
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          prop="packageName"
          label="套餐名称"
        />
        <el-table-column
          prop="description"
          label="套餐说明"
        >
          <template slot-scope="scope">
            <div class="limit-3-line">
              {{ scope.row.description ? scope.row.description : '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="售价"
        />
        <el-table-column
          prop="originalPrice"
          label="原价"
        />
        <el-table-column
          prop="flow"
          label="流量/月"
        />
        <el-table-column
          prop="packageDays"
          label="套餐月数"
        />
        <el-table-column
          label="套餐类型"
          prop="packageType"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.packageType === 0">优享</span>
            <span v-if="scope.row.packageType === 1">畅享</span>
            <span v-if="scope.row.packageType === 2">尊享</span>
          </template>
        </el-table-column>
        <el-table-column
          label="购买类型"
          prop="buyType"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.buyType === 0">现金</span>
            <span v-if="scope.row.buyType === 1">积分</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <!-- 展示设备激活 -->
            <span>{{ scope.row.state === 0 ? '启用' : '停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-link
              :underline="false"
              type="primary"
              @click="modify(scope.row)"
            >修改</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link
              :underline="false"
              type="danger"
              @click="doDelete(scope.row)"
            >删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
    <AddView
      :message="dialogFormVisible"
      :curId="curId"
      @closeFunction='getDialogFormVisible'
      @add-success="addSuccess"
    ></AddView>
  </div>
</template>

<script>
import AddView from './components/AddView.vue';
import WifiApi from '@/api/wifi.js'
export default {
  data() {
    return {
      form: {
        type: '',
        packageName: ''
      },
      curId: '',
      tableData: [],
      loading: true,
      dialogFormVisible: false,
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      selections: []
    }
  },
  components: { AddView },
  methods: {
    toggleSelection() {
      this.$refs.selections.clearSelection();
    },
    modify(row) {
      this.curId = row.id
      this.dialogFormVisible = true
    },
    getDialogFormVisible(flag) {
      this.dialogFormVisible = flag
    },
    handleSelectionChange(val) {
      this.selections = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    // 渲染列表
    getList() {
      this.loading = true;
      const params = {
        type: this.form.type,
        packageName: this.form.packageName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      }
      WifiApi.packageList({ ...params }).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
        this.loading = false;
      }).catch(e => {
        this.loading = false;
      })
    },
    // 查询按钮
    queryFunc() {
      this.pageIndex = 1
      this.getList();
    },
    addSuccess() {
      this.getList()
      this.getDialogFormVisible(false)
    },
    clearFunc() {
      this.pageIndex = 1
      this.form.type = ''
      this.form.packageName = ''
      this.getList();
    },
    addFunc() {
      this.curId = ''
      this.getDialogFormVisible(true)
    },
    doDelete(row) {
      let ids = []
      if (row) {
        ids = [row.id]
      } else {
        this.selections.forEach(item => {
          ids.push(item.id)
        })
      }
      this.$confirm('确定删除当前项？', '提示', {
        type: 'warning'
      }).then(() => {
        WifiApi.deletePackage({ ids }).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        })
      })
    }
  },
  mounted() {
    this.getList();
  }
}
</script>

<style scoped>
.mt {
  margin-top: 20px;
}

.tabBox {
  margin: 40px 0;
}

.box {
  padding: 10px;
}

.form {
  margin-right: 20px;
}

.btn {
  margin-left: 15px;
  display: inline-block;
}

.el-form-item {
  margin-bottom: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/views/ybwifi/package/index.vue